import { render } from "./ChangePasswordButton.vue?vue&type=template&id=52f24f2d&scoped=true&ts=true"
import script from "./ChangePasswordButton.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordButton.vue?vue&type=script&lang=ts"

import "./ChangePasswordButton.vue?vue&type=style&index=0&id=52f24f2d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f24f2d"],['__file',"src/components/ChangePasswordButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52f24f2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52f24f2d', __exports__)) {
    api.reload('52f24f2d', __exports__)
  }
  
  module.hot.accept("./ChangePasswordButton.vue?vue&type=template&id=52f24f2d&scoped=true&ts=true", () => {
    api.rerender('52f24f2d', render)
  })

}


export default __exports__